<template>
    <div>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'审核管理'},{name:'政策申报发布审核'}]" :title="'政策申报发布审核'"/> -->
            <!-- 选项卡 -->
            <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="待审核" name="1" v-if="authorities.indexOf('sys:permission:background:policy:declare:release:unAudit')!==-1"></el-tab-pane>
              <el-tab-pane label="审核记录" name="2" v-if="authorities.indexOf('sys:permission:background:policy:declare:release:audit')!==-1"></el-tab-pane>
            </el-tabs>
            <!-- 查询条件 -->
            <div class="retrieve" ref="condition">
                <div class="left">
                    <div class="child" v-show="tab==='2'">
                        <span class="name">审核结果</span>
                        <el-select v-model="sendInfoOne.checkStatus" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">提交日期</span>
                        <el-date-picker
                            size="small"
                            v-model="dateS"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :default-time="['24:00:00','23:59:59']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                    <el-button size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <!-- 表格1 -->
            <el-table
                v-show="tab==='1'"
                :data="tableData"
                @sort-change="sortChange"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="createName"
                    show-overflow-tooltip
                    
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="policyName"
                    show-overflow-tooltip
                    
                    width="200"
                    label="政策申报标题">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    label="操作"
                    
					v-if="authorities.indexOf('sys:permission:background:policy:declare:release:unAudit:button:view')!=-1||authorities.indexOf('sys:permission:background:policy:declare:release:unAudit:button:audit')!=-1"
                    width="200">
                    <template slot-scope="scope">
                        <el-button  size="small" type="primary" class="super" plain 
                        v-if="authorities.indexOf('sys:permission:background:policy:declare:release:unAudit:button:view')!=-1"
                         @click="check(scope.row)">查看</el-button>
                        <el-button size="small" type="primary" class="super" plain 
                        v-if="authorities.indexOf('sys:permission:background:policy:declare:release:unAudit:button:audit')!=-1"
                         @click="audit(scope.row)">审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 表格2 -->
            <el-table
                v-show="tab==='2'"
                :data="tableData"
                @sort-change="sortChange"
                ref="multipleTable"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="发布账号">
                </el-table-column>
                <el-table-column
                    prop="createName"
                    show-overflow-tooltip
                    
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="policyName"
                    show-overflow-tooltip
                    
                    width="200"
                    label="政策申报标题">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    prop="modifyUserName"
                    show-overflow-tooltip
                    
                    label="审核账号">
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    label="审核时间">
                </el-table-column>
                <el-table-column
                    prop="checkStatusValue"
                    show-overflow-tooltip
                    
                    label="审核结果">
                </el-table-column>
                <el-table-column
                    label="操作"
                    
                    width="100">
                    <template slot-scope="scope">
                        <el-button  size="small" type="primary" class="super" plain 
                        v-if="authorities.indexOf('sys:permission:background:policy:declare:release:audit:button:view')!=-1" 
                         @click="check(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref='pagination'>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
            <!-- 弹出成模块 -->
            <!-- 查看明细 -->
            <el-dialog
                title="申请信息"
                :visible.sync="dialogInfo"
                width="50%">
                <div class="basic">
                    <div class="boxChild">
                        <div class="basisTitle">账号信息</div>
                        <div class="child">
                            <div class="name">账号：</div>
                            <div class="content">{{detailInfo.userVo.userName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">账号类型：</div>
                            <div class="content">{{detailInfo.userVo.userTypeName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">姓名：</div>
                            <div class="content">{{detailInfo.userVo.realName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">邮箱：</div>
                            <div class="content">{{detailInfo.userVo.email}}</div>
                        </div>
                        <div class="child">
                            <div class="name">联系地址：</div>
                            <div class="content">{{detailInfo.userVo.contactAddress}}</div>
                        </div>
                    </div>
                    <div class="boxChild">
                        <div class="basisTitle">政策申报信息</div>
                        <div class="child">
                            <div class="name">政策申报标题：</div>
                            <div class="content">{{detailInfo.policyName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">适用行业：</div>
                            <div class="content">{{detailInfo.industry}}</div>
                        </div>
                        <div class="child">
                            <div class="name">适用地区：</div>
                            <div class="content">{{detailInfo.areaValue}}</div>
                        </div>
                        <div class="child">
                            <div class="name">来源：</div>
                            <div class="content">{{detailInfo.source}}</div>
                        </div>
                        <div class="child">
                            <div class="name">政策详情：</div>
                            <div class="content">
                                <pre v-html="detailInfo.policyDetails"></pre>
                            </div>
                        </div>
                        <div class="childMulti">
                            <div class="name">申报流程：</div>
                            <ul>
                                <li v-for="(item,i) in detailInfo.declareProcess" :key="i">
                                    {{i+1}}. {{item.content}}
                                </li>
                            </ul>
                        </div>
                        <div class="attachment">
                            <div class="name">附件：</div>
                            <ul class="content">
                                <li v-for="(item,i) in detailInfo.fileList" :key="i">
                                    <span>{{item.fileName}}</span><i class="el-icon-download" @click="open(item)"></i>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="boxChild" v-if="tab==='2'">
                        <div class="basisTitle">认证信息</div>
                        <div class="child">
                            <div class="name">审核结果：</div>
                            <div class="content">{{detailInfo.checkStatusValue}}</div>
                        </div>
                        <div class="child">
                            <div class="name">审核账号：</div>
                            <div class="content">{{detailInfo.modifyUserName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">审核时间：</div>
                            <div class="content">{{detailInfo.updateTime}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detailInfo.checkExplanation}}</div>
                        </div>
                    </div>
                </div>
            </el-dialog>
            <!-- 审核 -->
            <el-dialog
                title="审核"
                :visible.sync="dialogAudit"
                width="30%">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>审核结果：</div>
                        <el-radio-group v-model="sendInfoTwo.result">
                            <el-radio :label="item.value" v-for="(item,index) in statusList" :key="index">{{item.name}}</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.result']">错误提示：{{errors['sendInfoTwo.result']}}</div>
                    <div class="childTextarea">
                        <div class="name">说明：</div>
                        <div class="content"><el-input type="textarea" v-model="sendInfoTwo.checkRemark" show-word-limit maxlength="200" style="max-width:100%;"></el-input></div>
                    </div>
                    <div class="doubleBtn">
                        <el-button size="small" type="primary" @click="submit">确认</el-button>
                        <el-button size="small" @click="cancel">取消</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import timeMixins from "@/mixins/timeFormat";
// import breadcrumb from '../../components/breadcrumb';
import {getDict} from "@/axios";
export default {
    mixins:[timeMixins],
    components:{
        // breadcrumb
    },
    data(){
        return{
            loading:false,
            bHeight: void 0,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
            options: [{
                value: '2',
                label: '账号'
                }, {
                value: '3',
                label: '姓名'
            }, {
                value: '4',
                label: '政策申报标题'
            }],//检索下拉
            statusList:[],//审核结果
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                endDate:'',//结束时间
                startDate:'',//开始时间
                checkStatus:'',//审核结果
                id:"",//申请id
                userName:'',//账号
                name:'',//姓名
                title:'',//政策资讯标题
                property:null,//排序字段
                direction:null,//排序方式
            },//检索提交数据
            tab:'1',//选项卡
            getSelect:'',//检索下拉的值
            getValue:'',//检索输入框的值
            dateS:[],//日期
            tableData:[{name:'12assssssss'}],//表格数据
            currentPage:1,//当前页
            dialogInfo:false,//查看明细弹出层
            dialogAudit:false,//审核弹出层
            sendInfoTwo:{
                id:'',
                approvalModule:'policyDeclare',
                result:null,//审核结果
                checkRemark:'',//说明
            },//审核提交数据
            scopeListArray:[],
            scopeList:[],
            totalSize:null,
            detailInfo:{//查看详情
                userVo:{
                    userName:'',
                    userTypeName:'',
                    realName:'',
                    email:'',
                    contactAddress:'',
                },
                policyName:'',
                areaValue:'',
                guidelinesDetails:'',
                createTime:'',
                createUserName:'',
                source:"",
                policyDetails:"",
                declareProcess:"",
                modifyUserName:'',
                updateTime:'',
                fileList:[],
                checkStatusValue:'',
                checkExplanation:""
            }
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfoTwo.result':{
            test:function(){
                if(this.sendInfoTwo.result){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择审核结果'
        },
    },
    created(){
      this.getReviewResultList()
    },
    mounted(){
        const that = this
        // 审核结果
        // getDict('CHECK_STATUS').then(data=>{
        //     data.CHECK_STATUS.shift()
        //     that.statusList = data.CHECK_STATUS
        // })
        
        // 待审核
        if(that.authorities.indexOf('sys:permission:background:policy:declare:release:unAudit')==-1){
          that.tab='2'
        }
        // 待审核 和审核记录存在一个
        if(that.authorities.indexOf('sys:permission:background:policy:declare:release:unAudit')!=-1||that.authorities.indexOf('sys:permission:background:policy:declare:release:audit')!=-1){
          that.getData()
        }
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    },
    methods:{
      //获取字典 审核状态
      async getReviewResultList () {
          // const {code,data} = await this.$axiosz.get('backstage/sysDict/isShow/CHECK_STATUS')
          const {code,data} = await this.$axiosz.get('backstage/sysDict/auditOption')
          if (code == 200) {
                  this.statusList = data; 
              }
      },
      onReset(){
        this.getSelect='';//检索下拉的值
            this.getValue='';//检索输入框的值
            this.dateS=[];//日期
            this.sendInfoOne.currentPage=1;//当前页
            this.sendInfoOne.pageSize=20;//页条数
            this.sendInfoOne.checkStatus='';//审核结果
            this.sendInfoOne.endDate='';//结束时间
            this.sendInfoOne.startDate='';//开始时间
            this.sendInfoOne.id="";//申请id
            this.sendInfoOne.userName='';//账号
            this.sendInfoOne.name='';//姓名
            this.sendInfoOne.title='';//申请人姓名
            this.sendInfoOne.property = null
             this.sendInfoOne.direction = null
            this.totalSize=null;//总页码
            if(this.$refs.multipleTable) this.$refs.multipleTable.clearSort()
            if(this.$refs.table) this.$refs.table.clearSort()
            this.getData();
      },
        doLayout() {
            this.$nextTick(() => {
              if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
                this.$refs.multipleTable.doLayout()
              }
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        getData(){
           if(this.dateS&&this.dateS.length>0){
                this.sendInfoOne.startDate=this.dateS[0];
                this.sendInfoOne.endDate=this.dateS[1];
            }else{
                this.sendInfoOne.startDate=null;
                this.sendInfoOne.endDate=null;
            }
            this.sendInfoOne.id="";//申请id
            this.sendInfoOne.userName='';//账号
            this.sendInfoOne.name='';//姓名
            this.sendInfoOne.title='';//债权产品名称
            if(this.getSelect=='1'){ //申请id
                this.sendInfoOne.id=this.getValue;
            }else if(this.getSelect=='2'){ //账号
                this.sendInfoOne.userName=this.getValue;
            }else if(this.getSelect=='3'){ //姓名
                this.sendInfoOne.name=this.getValue;
            }else if(this.getSelect=='4'){ //标题
                this.sendInfoOne.policyName=this.getValue;
            }
            this.loading = true
            let url='';
            this.scopeList = []
            if(this.tab==='1'){
                url='backstage/policy/declare/pending/review/list';
                // this.scopeListArray[0].sysPermissionVoList.map(val=>{
                //     this.scopeList.push(val.permissionName)
                // })
            }else{
                url='backstage/policy/declare/audited/list';
                // this.scopeListArray[1].sysPermissionVoList.map(val=>{
                //     this.scopeList.push(val.permissionName)
                // })
            }
            this.$axiosc.get(url,{params:this.sendInfoOne}).then(res=>{
                this.loading = false
                if(res.code==200){
                    this.tableData=res.data.content;
                    this.totalSize=res.data.totalElements;
                }else{
                    this.$alert(res.msg)
                }
            }).catch(e=>{
              this.loading = false
            })
        },
        // 切换选项啦
        changeTab:function(tab){
            this.tab=tab.name;
            this.onReset()
        },
        //表格排序事件
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='asc';
            }else{
                order='desc';
            }
            this.sendInfoOne.property=prop;
            this.sendInfoOne.direction=order;
            this.getData();
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
        //查看明细
        check:function(row){
            // this.$axiosc.get('backstage/policy/declare/reviewLog/details/'+row.id).then(res=>{
            //     if(res.code == 200){
            //         this.detailInfo = res.data
            //         let value = []
            //         this.detailInfo.industry.map(val=>{
            //             value.push(val.value)
            //         })
            //         this.detailInfo.industry = value.join('/')
            //         if(this.detailInfo.fileList.length > 0){
            //             if(!this.detailInfo.fileList[0].frontPath){
            //                 let value = []
            //                 this.detailInfo.fileList.map(val=>{
            //                     value.push({fileName:val.fileName,filePath:val.filePath,frontPath:this.detailInfo.frontPath})
            //                 })
            //                 this.detailInfo.fileList = value
            //             }
            //         }
            //         this.dialogInfo=true;
            //     }
            // })
            this.$router.push({path: `/auditsManagement/releasePolicyDeclare/detail/${this.tab}`, query: {id: row.id, index: '/auditsManagement/releasePolicyDeclare'},param:{type:this.tab}})
        },
        //打开审核
        audit:function(row){
            this.sendInfoTwo.id = row.id
            this.sendInfoTwo.result = null
            this.sendInfoTwo.checkRemark = ''
            this.dialogAudit=true;
        },
        //取消按钮
        cancel:function(){
            this.$vuerify.clear();
            this.dialogAudit=false
        },
        //保存按钮
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                this.$axiosc.put('backstage/common/approval',this.$qs.stringify(this.sendInfoTwo)).then(res=>{
                    if(res.code == 200){
                        this.getData()
                        this.$message({
                            type: 'success',
                            message: '审核成功！',
                        });
                        this.dialogAudit = false
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.msg,
                        });
                    }
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>